module.exports = __webpack_public_path__ + "static/media/bhodi.28fc86cb.gif";